<template>
  <div class="cell">
    <van-cell size="large" :title="title" :is-link="isShowArrow" :to="routerLinkTo" :value="arrowValue" />
  </div>
</template>

<script>
import Cell from "@m/vant/Cell";
export default {
  data() {
    return {};
  },
  props: {
    isShowArrow: {
      type: Boolean
    },
    routerLinkTo: {
      type: String
    },
    title: {
      type: String
    },
    arrowValue: {
      type: String
    }
  },
  mixins: [Cell]
};
</script>
<style lang="scss" scoped>
.cell {
  .van-cell {
    background: none;
    font-weight: bold;
  }
  .van-cell__title {
    font-size: 18px;
  }
}
</style>